export default {
      id: "i-alternative-fz-usage",
      viewBox: "0 0 50 30",
      url: __webpack_public_path__ + "img/sprite.svg#i-alternative-fz",
      toString: function () {
        return this.url;
      }
    }